module.exports = __webpack_public_path__ + "static/logo-1d5002b022b00090582a2ab47382d13c.png";